import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  Button,
  Input,
  Space,
  Typography,
  Drawer,
  Form,
  Select,
  Spin,
  notification,
  message,
} from "antd";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../../Common/APIConstants";
import {
  ConverterConfigGrid,
  MeterConfigGrid,
} from "../../../../../../Common/UIConstants";
import { MeterDrawer } from "./MeterDrawer";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";
import { CloudCog } from "lucide-react";
const { Search } = Input;

const DashMeters = ({ selectedSiteID }) => {
  const [drawerOpen2, setDrawerOpen2] = useState(false);
  const [form] = Form.useForm();
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [rowData, setRowData] = useState([]);
  const mode = useSelector((state) => state.darkMode);
  const [isloading, setISLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);
  // const [selectedSiteID, setSelectedSiteID] = useState(null);
  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color)
  const [modules, setModules] = useState([]);
  const [selectedSiteName, setSelectedSiteName] = useState(null);
  const [optionconverter, setOptionConverter] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isAdd, setIsAdd] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filteredData, setFilteredData] = useState(rowData);
  const [client, setClient] = useState(null);
  const [meterCount, setMeterCount] = useState(0);

  const [selectedMeterID, setSelectedMeterID] = useState(
    localStorage.getItem("selectedSiteID") || selectedSiteID
  );
  const [excelImage, setExcelImage] = useState(null);
  const loggedIn = useSelector((state) => state.user);
  // console.log(loggedIn)
  useEffect(() => {
    setExcelImage(
      loggedIn?.images?.excelImage
        ? `data:image/png;base64,${loggedIn?.images?.excelImage}`
        : null
    );
  }, [loggedIn]);

  const handleSearch = (value) => {
    const fullQuery = value.trim().toLowerCase(); // full string
    const queryChars = fullQuery.split("");
    //console.log(fullQuery)
    //console.log(queryChars)

    const result = rowData.filter((item) =>
      Object.values(item).some((field) => {
        const fieldStr = String(field ?? "").toLowerCase();
        //console.log(fieldStr)
        return fieldStr.includes(fullQuery);
        // ||
        // queryChars.some((char) => fieldStr.includes(char))
      })
    );
    //console.log(result)

    setFilteredData(result);
  };

  useEffect(() => {
    setTimeout(() => {
      setISLoading(false);
    }, 2000);
  });

  const handleNotification = (msg) => {
    notification.open({
      message: msg,
      type: msg.includes("successfully") ? "success" : "success",
      placement: "topRight",
      duration: 3,
    });
  };

  //     const setIdSelected =(value) => {
  //   localStorage.setItem("selectedSiteID", value);
  //   //console.log(value)
  //   setSelectedSiteID(value);
  //   setRefetch(!refetch)
  // }
  const getResponse = () => {
    // setIsLoading(true);
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_METER}?SiteID=${selectedSiteID}`,
    })
      .then((res) => {
        //console.log(res)
        //   setIsLoading(false);
        //console.log(Array.isArray(res))
        if (Array.isArray(res)) {
          const updatedData = res.map((item) => ({
            ...item,
            actions: {
              update: handleUpdate,
              confirmDelete: handleDeleteSubmit,
            },
          }));
          //console.log(updatedData)
          setRowData(updatedData);
          setFilteredData(updatedData);
          // onClose();
        } else {
          //console.error('Expected array but got:', res);
        }
      })
      .catch((err) => {
        //   setIsLoading(false);
        //console.error('API request failed', err);
      });
  };

  useEffect(() => {
    setSelectedMeterID(selectedSiteID);
    localStorage.setItem("selectedSiteID", selectedSiteID);
  }, [selectedSiteID]);
  //console.log(refetch)
  useEffect(() => {
    //console.log(refetch)
    if (selectedMeterID) {
      getResponse();
    }
  }, [selectedMeterID, refetch]);
  //console.log(selectedMeterID)

  const handleDeleteSubmit = (meterID, departmentID, siteID) => {
    // if (!meterID || !departmentID || !siteID) {
    //   //console.error("Missing required data for deletion");
    //   return;
    // }
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_DEVICE_DETAILS}?METERID=${meterID}&DEPARTMENTID=${departmentID}&SITEID=${siteID}`,
    })
      .then(() => {
        handleNotification("Successfully Deleted", "success");
        setRefetch(!refetch);
        // setIdSelected(savedValue)
      })
      .catch((err) => {
        //console.error( err);
        handleNotification("Error while deleting", "error");
      });
  };


const getLicenseDetails = async () => {
  const url = `${APIConstants.GET_LICENSE_DETAILS}/1`;

  const res = await makeRequest({
    type: APIConstants.GET,
    url
  });

  return res?.[0]?.NoOfMeters;
};

const getMeterCount = async () => {
  const url = `${APIConstants.METERS_COUNT}`;

  const res = await makeRequest({
    type: APIConstants.GET,
    url
  });

  return res[0]?.totalMeterCount;
};


  const openDrawer2 = async() => {
    const MaxallowedMetersCount = await getLicenseDetails();
  const ActualMetersCount = await getMeterCount();

  if (Number(MaxallowedMetersCount) >=Number(ActualMetersCount)) {
    setDrawerOpen2(true);
    setIsAdd(true);
    setIsUpdate(false);
  }else{
    message.error("Meter count exceeded license limit!")
  }
 
  };
  const closeDrawer2 = () => {
    // form.resetFields()
    setDrawerOpen2(false);
  };

  const onFinish = (values) => {
    //console.log('Form submitted:', values);
    insertGroup(values);
    form.resetFields();
    closeDrawer2();
    setRefetch(!refetch);
  };

  const getConverter = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_CONVERTER}`,
    }).then((res) => {
      //console.log("Converter:", res);
      if (res && res.length > 0) {
        setOptionConverter(res);
      }
    });
  };

  useEffect(() => {
    if (optionconverter.length === 0) {
      getConverter();
    }
  }, [optionconverter]);

  const insertGroup = (formValues) => {
    //console.log(formValues);
    const body = {
      converterID: formValues.converterID,
      converterName: formValues.converterName,
      converterIP: formValues.converterIP,
      port: formValues.port,
      noofports: formValues.noofports,
      moduleType: formValues.converterType.toString(),
    };
    //console.log(body)
    const url = `${APIConstants.CONFIG_INSERT_CONVERTER}`;
    //console.log(url);
    // makeRequest({
    //   type: APIConstants.POST,
    //   url: url,
    //   body: body,
    // })
    //   .then((res) => {
    //     //console.log( res);
    //     setRefetch(!refetch);
    //     if (res && res.message) {
    //       // handleNotification("Converter successfully saved!", "success");
    //       handleNotification(res.message, "success");
    //     }
    //     // if (res ) {
    //     //   handleNotification("Converter successfully saved!", "success");
    //     //   // handleNotification(res.message,"success");
    //     //   setRefetch(!refetch)
    //     // }
    //   })
    //   .catch((err) => {
    //     //console.error(err);
    //     handleNotification(
    //       "An error occurred while saving the converter.",
    //       "error"
    //     );
    //   });
  };
  //console.log(isdarkMode)
  //console.log(rowData)

  const handleUpdate = (rowData) => {
    //console.log("Selected Row Data:", rowData);
    setSelectedRow(rowData); // Set selectedRow
    setDrawerOpen2(true);
  };

  //      const downloadDeviceExcel = (data) => {
  //       if (data.length === 0) {
  //         handleNotification("No data available to export", "error");
  //         return;
  //       }
  //   const formattedData = data.map((item, index) => ({
  //     "S.NO": index + 1,
  //     "Converter ID": item.sitE_ID,
  //     "Converter Name": item.sitename,
  //     "Device ID": item.meteR_METERID,
  //     "Device Name": item.metername,
  //     "Device Model": item.metermodel,
  //     "Module": item.module,
  //     "Device Supplier": item.meterSupplier,
  //     "IP Address": item.ipAddress,
  //     "Port No.": item.portNo,
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Device Details");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const fileData = new Blob([excelBuffer], {
  //     type: "application/octet-stream",
  //   });

  //   saveAs(fileData, "DeviceDetails.xlsx");
  // };

  // Helper to fetch image as ArrayBuffer
  const getImageBufferFromUrl = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const arrayBuffer = await response.arrayBuffer();
    return arrayBuffer;
  };
const downloadDeviceExcel = async (data) => {
  if (!data || data.length === 0) {
    handleNotification("No data available to export", "error");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Device Details");

  //   Step 1: Merge A1:B2 for logo
  worksheet.mergeCells("A1:B2");

  //   Step 2: Add smaller logo
  const imageUrl = excelImage ? excelImage : minnotra_logo;
  const imageBuffer = await getImageBufferFromUrl(imageUrl);
  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: "png",
  });

  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.1 },
    ext: { width: 100, height: 37 },
  });




  //   Step 3: Add Title "Device Details" in row 3
  worksheet.mergeCells("A3:J3"); // Merge across all columns (adjust if needed)
  const titleCell = worksheet.getCell("A3");
  titleCell.value = "Device Details";
  titleCell.font = { size: 14, bold: true };
  titleCell.alignment = { vertical: "middle", horizontal: "center" };

  //   Step 4: Header row at row 4
  const headerRowIndex = 4;
  const headers = [
    "S.NO",
    "Converter ID",
    "Converter Name",
    "Device ID",
    "Device Name",
    "Device Model",
    "Module",
    "Device Supplier",
    "IP Address",
    "Port No.",
  ];
  worksheet.insertRow(headerRowIndex, headers);

  //   Step 5: Style header row
  const headerRow = worksheet.getRow(headerRowIndex);
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" }, // Green
    };
    cell.font = {
      bold: true,
      color: { argb: "FFFFFFFF" }, // White
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  //   Step 6: Add data rows with borders starting from row 5
  data.forEach((item, index) => {
    const row = worksheet.addRow([
      index + 1,
      item.sitE_ID,
      item.sitename,
      item.meteR_METERID,
      item.metername,
      item.metermodel,
      item.module,
      item.meterSupplier,
      item.ipAddress,
      item.portNo,
    ]);

    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  //   Step 7: Auto column width based on longest value
  worksheet.columns.forEach((column) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, cellValue.length);
    });
    column.width = maxLength < 10 ? 10 : maxLength + 2; // min 10, +2 padding
  });

  //   Step 8: Save Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "DeviceDetails.xlsx");
};


  //console.log(isUpdate)
  //console.log(drawerOpen2)
  const updateRow = () => {
    setIsUpdate(true);
    setIsAdd(false);
  };

  return (
    <div className="">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
        <span
          level={4}
          className={` ${isdarkMode ? "text-white" : "text-black "}  text-xl  !mb-0`}
        >
          Devices
          {/* <span className="text-blue-500 text-sm">(240 Converters)</span> */}
        </span>
        <Space>
          <Search
            placeholder="Search"
            allowClear
            onSearch={handleSearch}
            style={{ width: 300 }}
          />
          <Button
            disabled={rowData.length == 0}
            onClick={() => downloadDeviceExcel(rowData)}
            icon={<FileExcelOutlined />}
          >
            Export Excel
          </Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={openDrawer2}>
            Add Device
          </Button>
        </Space>
      </div>

      <Spin indicator={<Spin size="large" />} spinning={loading}>
        <MeterConfigGrid
          refetch={refetch}
          setRefetch={setRefetch}
          data={filteredData}
          handleDeleteSubmit={handleDeleteSubmit}
          setIsUpdate={updateRow}
          handleUpdate={handleUpdate}
        />
      </Spin>

      {/* Right Drawer for Form */}
      <Drawer
        // className='overflow-x-hidden'
        className={` ${isdarkMode ? "my-drawer-body anticon-close" : "#000000"} overflow-x-hidden`}
        // title="Add Device Details"
        title={
          <div className={`${isdarkMode ? "text-white" : "text-black"}`}>
             {isUpdate?"Update Device Details":"Add Device Details"}
          </div>
        }
        placement="right"
        onClose={closeDrawer2}
        open={drawerOpen2}
        width={500}
        footer={
          <div className="flex justify-between px-4 py-2">
            <Button onClick={closeDrawer2}>Cancel</Button>
            <Button
              type="primary"
              onClick={() => {
                form.submit();
              }}
            >
              {isUpdate?"Update":"Add"}
            </Button>
          </div>
        }
      >
        <MeterDrawer
          onClose={closeDrawer2}
          isAdd={isAdd}
          isUpdate={isUpdate}
          selectedRow={selectedRow}
          form={form}
          onFinish={onFinish}
          refetch={refetch}
          setRefetch={setRefetch}
        />
        {/* <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}.
          
        >
          <Form.Item
            name="converterID"
            label="Converter ID"
            rules={[{ required: true, message: 'Enter converter ID' }]}
          >
            <Input placeholder="Enter converter ID" />
          </Form.Item>

          <Form.Item
            name="converterName"
            label="Converter Name"
            rules={[{ required: true, message: 'Enter converter name' }]}
          >
            <Input placeholder="Enter converter name" />
          </Form.Item>

          <Form.Item
            name="converterIP"
            label="Converter IP"
            rules={[{ required: true, message: 'Enter IP address' }]}
          >
            <Input placeholder="Enter converter IP" />
          </Form.Item>

          <Form.Item
            name="port"
            label="Port"
            rules={[{ required: true, message: 'Enter port number' }]}
          >
            <Input placeholder="Enter port" />
          </Form.Item>

          <Form.Item
            name="noofPorts"
            label="No. of Ports"
            rules={[{ required: true, message: 'Enter number of ports' }]}
          >
            <Input placeholder="Enter no of ports" type="number" />
          </Form.Item>

          <Form.Item
            name="converterType"
            label="Converter Type"
            rules={[{ required: true, message: 'Select converter type' }]}
          >
            <Select placeholder="Select converter type">
                 {modules.map((item) => (
                      <Select.Option mode='multiple' key={item.moduleId} value={item.moduleName}>
                        {item.moduleName} 
                      </Select.Option>
                    ))}
            </Select>
          </Form.Item>
        </Form> */}
      </Drawer>
    </div>
  );
};

export default DashMeters;
